
@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
                               (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form190">
    <dst-template-header [parentFormGroup]="form190" [overwriteFormName]="'STATEMENT REQUIRED PURSUANT TO SECTION 332'"
      [dropDownOptions]="headerOptions" [sameLineText]="'BY A CORPORATION RECEIVING A LIQUIDATING DISTRIBUTION'"
      [allowOptional]="true" (formOptionChanged)="onFormOptionChanged($event)"
      (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <ol style="margin: 15px;">
      <li>Parties
        <div formGroupName="transferorDetails">
          <div class="ap-form-field-my-wrapper">
            <ol class="inner-list">
              <li>
                <dst-template-leid-selector [label]="'Please specify the LEID of the Transferee (Recipient)'"
                  [labelId]="'101'" (onSelectedLEChanged)="onTransfereeChanged($event)" class="required-field">
                </dst-template-leid-selector>
                <!-- <div class="a-form-error error-leid" *ngIf="transferee === undefined">
                Please specify the Transferee
              </div> -->
                <div class="entity-details">
                  <span>Name of Transferee:</span><span class="template-color-blue">{{!transferee ? '' :
                    transferee.ENTITY}}</span>
                </div>
                <div class="entity-details">
                  <span>EIN:</span><span class="template-color-blue">{{!transferee ? '' :
                    (transferee.EIN ? transferee.EIN : 'N/A')}}</span><span>, Recipient&nbsp;a</span>
                </div>
                <div class="entity-details">
                  <span></span><span class="template-color-blue">{{!transferee ? '' :
                    transferee.COUNTRYINC + (transferee | taxtype: transferee?.TAXTYPECODE: entityNameChangeOnDate)}}</span><span>;&nbsp;and</span>
                </div>
              </li>
              <li>
                <dst-template-leid-selector
                  [label]="'Please specify the LEID of the Transferor (the Liquidating Corporation)'" [labelId]="'100'"
                  (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field">
                </dst-template-leid-selector>
                <!-- <div class="a-form-error error-leid" *ngIf="transferor === undefined">
                Please specify the Transferor
              </div> -->
                <!-- </div> -->
                <div class="entity-details">
                  <span>Name of Transferor:</span><span class="template-color-blue">{{!transferor ? '' :
                    transferor.ENTITY}}</span>
                </div>
                <div class="entity-details">
                  <span>EIN:</span><span class="template-color-blue">{{!transferor ? '' : (transferor.EIN ? transferor.EIN : 'N/A')}}</span><span>,
                    the
                    Liquidating Corporation, a
                  </span>
                </div>
                <div class="entity-details">
                  <span></span><span class="template-color-blue">{{!transferor ? '' : transferor.COUNTRYINC +
                    (transferor | taxtype: transferor?.TAXTYPECODE: entityNameChangeOnDate)}}</span>&nbsp;
                </div>
              </li>
            </ol>

            <!-- <div formArrayName="transferors"> -->
            <!-- <div class="ap-form-field-my-wrapper" *ngFor="let transferor of transferors.controls; let i = index;"> -->

            <div class="inline-paragraphs">
              <p>
                Pursuant to Treasury Reg. Sec. 301.7701-3(c)(1)(iii), the Liquidating Corporation, an eligible
                entity with a
                single
                owner, elected via Form 8832 - Entity Classification Election to be disregarded as a separate entity for
                U.S. tax purposes, effective&nbsp;
                @if (nameChangeChecked) {
<app-date-picker-with-clear
                 
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="'required-field'"
                  [required]="true"
                  (dateChange)="dateChange($event, 5)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(5)"
                  [(ngModel)]="effectiveDate"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
}

                &nbsp;. This election constitutes a deemed liquidation of the Liquidating Corporation to which Code Sections 332
                applies.

              </p>
            </div>
          </div>
        </div>
      </li>
      <li>The date(s) of all distribution(s) (whether or not pursuant to the plan) by the liquidating corporation during the current tax year;
        <div formGroupName="datesTransfer">
          <app-date-picker-with-clear
            [minDate]="beginDate"
            [maxDate]="endDate"
            [datePickerClass]="'required-field'"
            [required]="true"
            (dateChange)="dateChange($event, 1)"
            (datePickerClick)="onDPOpen()"
            (clearClick)="clearDate(1)"
            [(ngModel)]="defaultDate"
            [ngModelOptions]="{standalone: true}">
          </app-date-picker-with-clear>
          <!-- <div class="a-form-error"
            *ngIf="defaultDate === null">
            Please specify the Liquidation Date
          </div> -->
        </div>
      </li>
      <li>Properties Transferred:
        <div formGroupName="propertiesDetails">
          <p>
            The fair market value and basis of assets of the liquidating corporation that have been or will be
            transferred
            to any recipient corporation, aggregated as follows:
          </p>
          <ol class="inner-list">
            <li>
              <div class="list-content a-textarea-box a-field-length-validation">
                <span class="a-form-label textarea-label" style="font-size: inherit;">Importation property distributed in a loss importation transaction, as defined in Section 1.362-3(c)(2) and (3) (except that 'section 332 liquidation' is substituted for 'section 362 transaction'), respectively:</span>
                <ap-field [fieldId]="'310'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="importationProp" [ngModelOptions]="{standalone: true}" aria-label="310"></textarea>
                  <ap-field-counter [max]="1000" [value]="importationProp"></ap-field-counter>
                </ap-field>
              </div>
            </li>
            <li>
              <div class="list-content a-textarea-box a-field-length-validation">
                <span class="a-form-label textarea-label" style="font-size: inherit;">Property with respect to which gain or loss was recognized on the distribution:</span>
                <ap-field [fieldId]="'330'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="gainLossPropertyDesc" [ngModelOptions]="{standalone: true}" aria-label="330"></textarea>
                  <ap-field-counter [max]="1000" [value]="gainLossPropertyDesc"></ap-field-counter>
                </ap-field>
              </div>
            </li>
            <li>
              <div class="list-content">
                <span class="a-form-label list-item-label" style="cursor: default; font-size: inherit;">Property not described in paragraph (a)(3)(i) or (ii) of this section;</span>
                <table class="table-layout">
                  <tbody>
                    <tr>
                      <td colspan="3">
                        @if (showImport) {
<ap-button [compact]="true" [btnType]="'primary'" [label]="'Import Domestic or Foreign Trial Balance Data'"
                          class="import-btn ap-mr-spacing-3" (onClick)="import()" [disabled]="!effectiveDate">
                        </ap-button>
}
                        @if (showTotal) {
<ap-checkbox [styleClass]="'a-mx-10 import-btn'"
                          (onChange)="total($event)">
                          <span>Report TB Data on Total Net Assets basis</span>
                        </ap-checkbox>
}
                      </td>
                      <td>
                        <ap-dropdown [list]="propertyValBasisOptions" [selectType]="'single'" [showSearchbox]="true"
                          [title]="'** Select a basis **'" [inputAriaLabel]="'** Select a basis **'" (onSelect)="selectBasisOption($event)"
                          [optionName]="'text'"
                          [hideTitleOnInput]="true" [(ngModel)]="selectedBasisItem" [ngModelOptions]="{standalone: true}" class="show-label field-full-width">
                          @for (item of propertyValBasisOptions; track trackByIndex($index)) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                            [optionName]="'text'"
                            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                        </ap-dropdown>
                        <!-- <div class="a-form-error" *ngIf="selectedBasis === -1">
                          Please select a Basis section
                        </div> -->
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td><span>{{selectedBasisName}} Basis to the Corporation, the liquidating company</span></td>
                      <td><span>Fair Market Value on Date of Distribution</span></td>
                    </tr>
                    <tr>
                      <td colspan="2"></td>
                      <td class="header-column"><span>Description</span></td>
                      <td class="amount-cell">
                        <ap-dropdown [list]="currencyOptions[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
                          [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyOneChange($event)"
                          [optionName]="'text'"
                          [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem" [ngModelOptions]="{standalone: true}" noScrollOnOpen class="show-label currency-dropdown field-full-width">
                          @for (item of currencyOptions[0]?.data || []; track trackByIndex($index)) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                            [optionName]="'text'"
                            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                        </ap-dropdown>
                        <!-- <div class="a-form-error" *ngIf="selectedCurrency === 0">
                          Please select Fair Market value Currency type
                        </div> -->
                      </td>
                      <td class="amount-cell">
                        <ap-dropdown [list]="currencyOptions2[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
                          [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyTwoChange($event)"
                          [optionName]="'text'"
                          [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem2" [ngModelOptions]="{standalone: true}" noScrollOnOpen class="show-label currency-dropdown field-full-width">
                          @for (item of currencyOptions2[0]?.data || []; track trackByIndex($index)) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                            [optionName]="'text'"
                            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                        </ap-dropdown>
                      </td>
                    </tr>
                    <ng-container formArrayName="additionalPropsDetails">
                      @for (p of additionalPropsDetails.controls; track p; let i = $index) {
<tr>
                        <ng-container [formGroup]="$any(p)">
                          <td style="width: 3%;">
                            @if (i > 0) {
<ap-button class="btn-plus-minus" [btnType]="'primary'" [compact]="true"
                              [ariaLabel]="'Remove property row'"
                              [icon]="'minus-outline'" [add]="true"
                              (onClick)="removeAdditionalPropDetailsAt(i)">
                            </ap-button>
}
                          </td>
                          <td style="width: 3%;">
                            <ap-button class="btn-plus-minus" [btnType]="'primary'" [compact]="true"
                              [ariaLabel]="'Add property row'"
                              [icon]="'plus-outline'" [add]="true"
                              (onClick)="addAdditionalPropDetails()">
                            </ap-button>
                          </td>
                          <td style="width: 50%;">
                            <ap-field [title]="''" [fieldId]="i + 'a'" [hideTitleOnInput]="true">
                    <input appkit-field formControlName="description" [attr.aria-label]="i + 'a'" />
                            </ap-field>
                          </td>
                          <td class="amount-cell" style="width: 22%;">
                            <ap-field [title]="''" [fieldId]="i + 'b'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field amount-column'"
                              [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="transferorBasis" [attr.aria-label]="i + 'b'"
                                (ngModelChange)="onChangeNumber({value: $event}, i)" />
                            </ap-field>
                          </td>
                          <td class="amount-cell" style="width: 22%;">
                            <ap-field [title]="''" [fieldId]="i + 'c'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field amount-column'"
                              [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="fairMarketVal" [attr.aria-label]="i + 'c'" />
                            </ap-field>
                          </td>
                        </ng-container>
                      </tr>
}
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </li>
          </ol>
        </div>
      </li>
      <li>The date and control number of any private letter ruling(s) issued by the Internal Revenue Service in
        connection
        with the liquidation:
        <div id="step4" formGroupName="privateLetterRul">
          <app-date-picker-with-clear
            [minDate]="beginDate"
            [maxDate]="endDate"
            [datePickerClass]="''"
            [required]="false"
            (dateChange)="dateChange($event, 2)"
            (datePickerClick)="onDPOpen()"
            (clearClick)="clearDate(2)"
            [(ngModel)]="liquidationDate2"
            [ngModelOptions]="{standalone: true}">
          </app-date-picker-with-clear>
          <ap-field [fieldId]="'401'" [title]="''" [hideTitleOnInput]="true" [styleClass]="'plr-control-num-field'" (click)="onDPOpen()">
                    <input appkit-field [(ngModel)]="controlNum" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="401" />
          </ap-field>
        </div>
      </li>
      <li>The plan of complete liquidation was adopted on
        <div formGroupName="liabilitiesAssumed">
          <app-date-picker-with-clear
            [minDate]="beginDate"
            [maxDate]="endDate"
            [datePickerClass]="''"
            [required]="false"
            (dateChange)="dateChange($event, 4)"
            (datePickerClick)="onDPOpen()"
            (clearClick)="clearDate(4)"
            [(ngModel)]="adoptedDate"
            [ngModelOptions]="{standalone: true}">
          </app-date-picker-with-clear>
        </div>
      </li>
      <li>The recipient corporation hereby represents that: The liquidation was completed on
        <div formGroupName="liquidationState">
          <app-date-picker-with-clear
            [minDate]="beginDate"
            [maxDate]="endDate"
            [datePickerClass]="''"
            [required]="false"
            (dateChange)="dateChange($event, 3)"
            (datePickerClick)="onDPOpen()"
            (clearClick)="clearDate(3)"
            [(ngModel)]="acquiredDate"
            [ngModelOptions]="{standalone: true}">
          </app-date-picker-with-clear> <br />
          <div class="supp-info-wrapper" formGroupName="suppInfo">
            <div>Additional Information:</div>
            <ap-field [fieldId]="'550'" [title]="''" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="info" [ngModelOptions]="{standalone: true}" aria-label="550"></textarea>
            </ap-field>
          </div>
          <!-- <div class="ap-form-field-my-wrapper" formGroupName="branchInfo">
            <ap-field [fieldId]="'551'" [title]="'Please specify the LEID of the Branch Entity'">
              <input appkit-field formControlName="branchLEID" aria-label="551" />
            </ap-field>
          </div> -->
          <!-- <div class="branch-entity-details"> -->
          <dst-template-leid-selector [isBranchEntity]="true" [label]="'Please specify the LEID of the Branch Entity:'"
            [labelId]="'3'" (onSelectedLEChanged)="onBranchEntityChanged($event)" class="entity-label">
          </dst-template-leid-selector>
          <div class="entity-details">
            <span>Branch Entity Name:</span><span class="template-color-blue">{{!branchEntity ? '' : branchEntity.ENTITY}}</span>
          </div>
          <div class="leid-list" style="margin-top: 15px;">
            <span>LEIDs: </span>
            <div>
              @if (transferee) {
<span class="template-color-blue">{{ transferee.LEID }}</span>
}@if (transferor) {
<span>
                / </span>
}@if (transferor) {
<span class="template-color-blue">{{ transferor.LEID }}</span>
}
            </div>
          </div>
        </div>
      </li>
    </ol>
  </div>
</div>
@if (showChildDisclosureOptionModal) {
<ap-modal #showChildDisclosureOption
         
          [appModalId]="'child-disclosure-option'"
          [ariaLabel]="'Proceed to Form 926?'"
          [title]="'Proceed to Form 926?'"
          [closable]="true"
          [style]="{'width': '31.25rem'}"
          (onClose)="onChildDisclosureModalClose()">
  <div class="sec332-id190-modal-body">
    <p>
      This disclosure has been flagged as a potential outbound transfer of property to a Foreign Corporation requiring the completion of Form 926. See Form 926 instructions and Treas. Reg. Sec.1.367(e)-2(b)(2)(i)(c)(2) or (iii)(D) for further details.
    </p>
    <p class="m-0">Proceed to Form 926?</p>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3" [label]="'Cancel'" (onClick)="onProceedToChildFormOK('false')"></ap-button>
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'OK'" (onClick)="onProceedToChildFormOK('true')"></ap-button>
  </ng-template>
</ap-modal>
}
